<div class="gi-card" (click)="openGame()" [title]="game.name">
  <div class="gi-img-wrap">
    <img
      *ngIf="!game.image"
      [src]="(game.uniqname | gameThumbnail) + '.svg'"
      class="gi-img"
      [alt]="game.name" />
    <img
      *ngIf="game.image"
      [src]="game.image | gameThumbnail"
      class="gi-img"
      [alt]="game.name" />
  </div>
  <div class="gi-name">{{ game.name }}</div>
  <app-progress-bar-stars
    *ngIf="game.checkResult"
    [score]="game.bestScore"
    class="gi-stars">
  </app-progress-bar-stars>
  <div class="gi-play-hint" *ngIf="!game.checkResult">
    <i class="fa-solid fa-play"></i>
    <span translate>Jouer</span>
  </div>
</div>
